import { render, staticRenderFns } from "./StorageRoomDetail.vue?vue&type=template&id=8fe0ebb8"
import script from "./StorageRoomDetail.vue?vue&type=script&lang=js"
export * from "./StorageRoomDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports